import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { FooterReport, Gap, GridInline, LabelTitle, Line } from "../../../../components/Global";
import "react-loading-skeleton/dist/skeleton.css";
import { CONFIG_DEV } from "../../../../config/ConfigDev";
import accountManagement from "../../../../apis/accountManagement";
import LoaderModal from "../../../../components/modal/LoaderModal";
import PageTwo from "./PageTwo";
import LoadingPage from "./LoadingPage";
// import jsonFile from "./rpt-pmt-matrikulasi.json";

const PageOne = ({
    idJadwalCbt,
    idKelas,
    kodeTahunAjaran,
    kuotaMatematika,
    kuotaFisika,
    kuotaBiologi,
    kuotaKimia,
    kuotaInformatika,
    kuotaGeografi,
    kuotaSosiologi,
    kuotaEkonomi,
    kuotaAntropologi,
    kuotaBahasaInggris,
    kuotaBahasaIndonesia,
    kuotaBahasaAsing,
    kuotaVokasiDanPrakarya,
}) => {
    const [fetching, setFetching] = useState(false);
    const [detailSekolah, SetDetailSekolah] = useState([]);
    const [listFinalJurusan, SetListFinalJurusan] = useState([]);
    const [openPage, setOpenPage] = useState(false);
    const [riasec, setRiasec] = useState(false);

    const today = new Date();
    const suflix = today.getHours() >= 12 ? " PM" : " AM";
    const dateTime = today.getDate() + "/" + (today.getMonth() + 1) + "/" + today.getFullYear() + ", " + today.getHours() + "." + today.getMinutes() + suflix;

    useEffect(() => {
        const getDatas = async () => {
            setFetching(true);
            const response = await accountManagement
                .post(CONFIG_DEV.REPORT_PEMETAAN_PAGE_ONE, {
                    idJadwalCbt: idJadwalCbt,
                    idKelas: idKelas,
                    kodeTahunAjaran: kodeTahunAjaran,
                    kuotaMatematika: kuotaMatematika,
                    kuotaFisika: kuotaFisika,
                    kuotaBiologi: kuotaBiologi,
                    kuotaKimia: kuotaKimia,
                    kuotaInformatika: kuotaInformatika,
                    kuotaGeografi: kuotaGeografi,
                    kuotaSosiologi: kuotaSosiologi,
                    kuotaEkonomi: kuotaEkonomi,
                    kuotaAntropologi: kuotaAntropologi,
                    kuotaBahasaInggris: kuotaBahasaInggris,
                    kuotaBahasaIndonesia: kuotaBahasaIndonesia,
                    kuotaBahasaAsing: kuotaBahasaAsing,
                    kuotaVokasiDanPrakarya: kuotaVokasiDanPrakarya,
                })
                .catch(function (error) {
                    console.error("Error HW_REPORT_BY_KP", error);
                });

            if (response) {
                if (response.data.data) {
                    const responseAPI = response.data.data;
                    console.log("====================================");
                    console.log("Response Page One ", responseAPI);
                    console.log("====================================");

                    SetDetailSekolah(responseAPI.detailSekolah);
                    SetListFinalJurusan(responseAPI.listFinalJurusanRekomendasiPlacement);
                    setRiasec(responseAPI.isRiasec);
                }
                setFetching(false);
                setOpenPage(true);
            }
        };
        getDatas();
    }, []);

    require("../Pemetaan.css");
    return (
        <>
            <LoaderModal isFetching={fetching} />
            <div className="report-page">
                <div className="cardLine">
                    {/* header */}
                    <div>
                        <div className="pnl-header">
                            <div className="card-page">
                                <span style={{
                                    fontSize: '26px',
                                    color: '#FFF',
                                    fontWeight: 500,
                                    fontFamily: 'lucida grande'
                                }}>01</span>
                            </div>
                            <div className="pnl-date">
                                https://eduprime.co.id
                            </div>
                        </div>
                        <div className="header-first-page" style={{ padding: '0px' }}>
                            <div className="text-header" style={{ padding: '0px' }}>
                                <div className="title-header2" style={{ color: '#015E56' }}>SCHOOL ASSESSMENT REPORT</div>
                            </div>
                            <div>
                                <p className="title-header2" style={{ color: '#015E56', fontWeight: '500', marginTop: '10px' }}>Asesmen Diagnostik</p>
                            </div>
                        </div>
                    </div>
                    <div className="pnl-profile" style={{ marginTop: '5%' }}>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/icon-sekolah.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Nama Sekolah</span>
                                <p className="label-profile-value">{detailSekolah.namaSekolah}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/mdi_date.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Jumlah Siswa</span>
                                <p className="label-profile-value" style={{ verticalAlign: "middle" }}>{detailSekolah.totalSiswa}</p>
                            </div>
                        </div>
                        <div className="card-profile">
                            <div>
                                <img src="/assets/image/mdi_child.svg" width="60px" alt="" />
                            </div>
                            <div>
                                <span className="label-profile-name">Tanggal Pelaksanaan</span>
                                <p className="label-profile-value">{detailSekolah.tanggalPelaksanaan}</p>
                            </div>
                        </div>
                    </div>
                    <div className="card-tbl">
                        <div className="tbl-head">
                            <GridInline width={"100%"} padding={15} marginLeft={15}>
                                <GridInline width={"48%"} marginLeft={15} paddingTop={10} paddingBottom={10}>
                                    <LabelTitle label={"Mata Pelajaran"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Recomendation"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                                <GridInline width={"25%"} textAlign={"center"}>
                                    <LabelTitle label={"Placement"} size={20} bolder={800} color={"#000"} />
                                </GridInline>
                            </GridInline>
                        </div>
                        <div className="table-result">
                            {listFinalJurusan.map((hasilPemetaan, i) => {
                                return (
                                    <div key={i}>
                                        <GridInline width={"100%"} padding={15} marginLeft={15}>
                                            <GridInline width={"48%"} marginLeft={15} paddingTop={10}>
                                                {hasilPemetaan.namaJurusan}
                                            </GridInline>
                                            <GridInline width={"25%"} textAlign={"center"}>
                                                {hasilPemetaan.totalRekomendasi} Siswa
                                            </GridInline>
                                            <GridInline width={"25%"} textAlign={"center"}>
                                                {hasilPemetaan.totalPlacement} Siswa
                                            </GridInline>
                                        </GridInline>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
                <Gap height={40} />
            </div>

            {openPage ? <PageTwo idJadwalCbt={idJadwalCbt} idKelas={idKelas} kodeTahunAjaran={kodeTahunAjaran} schoolName={detailSekolah.namaSekolah} isRiasec={riasec} /> : <LoadingPage />}
        </>
    );
};

export default PageOne;
